export const versions = {
  version: "1.0.183",
  revision: "5c18873b4",
  branch: "HEAD",
  gitInfo: {
    dirty: true,
    raw: "v1.0.183-5316-g5c18873b4-dirty",
    hash: "g5c18873b4",
    distance: 5316,
    tag: "v1.0.183",
    semver: {
      options: { loose: false, includePrerelease: false },
      loose: false,
      raw: "v1.0.183",
      major: 1,
      minor: 0,
      patch: 183,
      prerelease: [],
      build: [],
      version: "1.0.183"
    },
    suffix: "5316-g5c18873b4-dirty",
    semverString: "1.0.183+5316.g5c18873b4.dirty"
  }
};
